import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { Lock, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  if (user) {
    navigate("/admin/dashboard", { replace: true });
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Errore di accesso");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <a href="/" className="inline-flex items-center gap-2 text-[#A3A3A3] hover:text-white transition-colors mb-12 font-mono text-sm">
          <ArrowLeft size={16} /> TORNA AL SITO
        </a>
        <div className="border border-white/10 bg-[#121212] p-10">
          <div className="flex items-center gap-3 mb-8">
            <Lock size={24} className="text-[#FF3366]" />
            <h1 className="font-heading text-2xl font-bold tracking-tight">Admin Panel</h1>
          </div>
          {error && (
            <div data-testid="login-error" className="bg-red-500/10 border border-red-500/30 text-red-400 px-4 py-3 mb-6 font-mono text-sm">
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-xs font-mono tracking-widest text-[#A3A3A3] mb-2">EMAIL</label>
              <input
                data-testid="admin-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border-b-2 border-white/20 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#FF3366] transition-colors font-mono"
                placeholder="admin@ninfa.eu"
                required
              />
            </div>
            <div>
              <label className="block text-xs font-mono tracking-widest text-[#A3A3A3] mb-2">PASSWORD</label>
              <input
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent border-b-2 border-white/20 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#FF3366] transition-colors font-mono"
                placeholder="Password"
                required
              />
            </div>
            <button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-[#FF3366] text-white font-bold uppercase tracking-widest px-8 py-4 hover:bg-white hover:text-black transition-colors disabled:opacity-50"
            >
              {loading ? "ACCESSO..." : "ACCEDI"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
